/* eslint-disable react/prop-types */
import React from 'react';
import classNames from 'classnames';
import styles from './Modal.Body.module.scss';

const ModalBody: React.FC<React.PropsWithChildren<React.HTMLProps<HTMLDivElement>>> = ({
  className,
  children,
  ...props
}) => (
  <div className={classNames(styles.modalBody, className)} {...props}>
    {children}
  </div>
);

export default ModalBody;
